import { render } from "./Product.vue?vue&type=template&id=27d3dfdd"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"

import "./Product.vue?vue&type=style&index=0&id=27d3dfdd&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__